define('editor/edit/layers/edit/markerStyleTracker',[], function () {
  // singleton, so we get the same instance every time
  return {
    previousEditStyle: null,

    saveStyleFromMarker: function(markerState) {
      this.previousEditStyle = {
        icon: markerState.selectedicon(),
        iconColour: markerState.iconColour(),
        iconSize: markerState.iconSize(),
        iconVisible: markerState.visibilityOptions.iconVisible(),

        paddleColour: markerState.paddleColour(),
        paddleVisible: markerState.visibilityOptions.paddleVisible(),

        labelTextSize: markerState.textSize(),
        labelAlignment: markerState.textAlign(),
        labelTextColor: markerState.labelTextColor(),
        labelGlowColour: markerState.textShadowColour(),
        labelVisible: markerState.visibilityOptions.labelVisible()
      };
    }
  };
});
